export default import.meta.ROLLUP_FILE_URL_O0V5WS5$4bim9OQ6gLASIg;